// Converte os filtros aplicados <-> query string da URL (arrays viram "a,b")
export function toQuery(fields, filters) {
  const q = {};
  fields.forEach(({ key }) => {
    const v = filters[key];
    if (Array.isArray(v) ? v.length : v !== undefined && v !== "") {
      q[key] = Array.isArray(v) ? v.join(",") : String(v);
    }
  });
  return q;
}

export function fromQuery(fields, query) {
  const f = {};
  fields.forEach(({ key, type }) => {
    const v = query[key];
    if (v === undefined || v === "") return;
    f[key] = type === "multi" ? String(v).split(",") : String(v);
  });
  return f;
}
